import { BatchStatus } from "@wingspanhq/wingspan-api-sdk";
import { UrlQueryFilter } from "../../../../shared/hooks/useUrlQuery";

/** Sentinel for the leading "All" option — means "send no status filter". */
export const STATUS_FILTER_ALL = "All";

/**
 * `Batch.status` is the same enum for both import types, so the payables and
 * contractors tabs filter on exactly the same values.
 */
export interface ImportBatchFilter extends UrlQueryFilter {
  status?: BatchStatus | typeof STATUS_FILTER_ALL;
}
